module.exports = __webpack_public_path__ + "assets/img/service-module2-1.108bdf27.jpg";